import React from "react";

/**
 * Reusable modal component with customizable title, content, and actions
 */
const ModalComponent = ({ isOpen, onClose, title, children, confirmText, onConfirm, isLoading = false, loadingText = "Please wait..." }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed lg:ml-[15rem] inset-0 flex items-center justify-center bg-black bg-opacity-70 z-[1000]">
      <div className="bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-6 w-full max-w-md mx-4 animate-fade-in">
        <h3 className="text-xl font-bold text-pink-200 mb-4">{title}</h3>
        <div className="mb-6">{children}</div>
        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="text-base px-4 py-2 text-white bg-slate-900/70 rounded-md hover:bg-red-900/40 transition-colors active:translate-y-0.5 active:shadow-none">
            Cancel
          </button>
          {confirmText && (
            <button
              onClick={() => {
                onConfirm();
              }}
              disabled={isLoading}
              className="text-base px-4 py-2 text-white bg-gradient-to-r from-red-800 via-red-900 to-red-950 rounded-md hover:opacity-90 transition-all relative active:translate-y-0.5 active:shadow-none"
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  {loadingText}
                </div>
              ) : (
                confirmText
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalComponent;
